function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAgreements(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 1024 1024",
    fill: "#000000",
    className: "icon",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M695.986 847.98H472c-4.422 0-8-3.578-8-8s3.578-8 8-8h223.988c4.42 0 7.998 3.578 7.998 8s-3.58 8-8 8z",
    style: {
      fill: "rgba(7, 132, 183, 0.737)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M599.992 863.978c-0.782 0-1.562-0.11-2.312-0.344a7.992 7.992 0 0 1-5.688-7.656v-29.232c-12.61 10.812-31.498 23.516-47.684 20.86-4.704-0.782-10.5-3.078-15.422-8.984a650.89 650.89 0 0 1-18.86 22.608 7.962 7.962 0 0 1-11.28 0.782 7.986 7.986 0 0 1-0.782-11.28 587.472 587.472 0 0 0 23.046-28.266c-5.876-21.138 0.82-39.778 10.078-48.622 7-6.688 15.734-8.61 23.904-5.266 3.688 1.484 6.25 4.468 7.188 8.39 2.344 9.89-9.016 29.17-23.06 48.292 3 5.688 6.406 6.312 7.656 6.532 14.544 2.734 41.2-21.998 47.028-28.874 2.156-2.562 5.782-3.546 8.906-2.39 3.14 1.156 5.282 4.094 5.282 7.454v21.576l17.342-26.014a8.02 8.02 0 0 1 6.656-3.562h31.998c4.422 0 8 3.578 8 8a7.994 7.994 0 0 1-8 7.998h-27.718l-29.622 44.436a7.984 7.984 0 0 1-6.656 3.562z m-53.87-80.884c-1.094 0.218-2.438 0.86-3.968 2.328-3.688 3.498-6.5 9.904-7.156 17.654 5.732-8.546 9.81-15.67 11.124-19.982zM935.97 927.974a7.97 7.97 0 0 1-6.654-3.562l-32-47.998a7.974 7.974 0 0 1-0.938-6.966l15.594-46.764v-14.702c0-4.422 3.578-8 8-8s8 3.578 8 8v15.998c0 0.86-0.14 1.718-0.406 2.532l-14.766 44.28 29.826 44.748a7.988 7.988 0 0 1-2.218 11.092 8.018 8.018 0 0 1-4.438 1.342z",
    style: {
      fill: "rgba(7, 132, 183, 0.737)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M935.97 927.974a8.014 8.014 0 0 1-4.436-1.344 7.986 7.986 0 0 1-2.218-11.092l29.824-44.748-14.764-44.28a8.16 8.16 0 0 1-0.406-2.532v-15.998c0-4.422 3.578-8 8-8a7.994 7.994 0 0 1 7.998 8v14.702l15.594 46.764a7.968 7.968 0 0 1-0.938 6.966l-31.998 47.998a7.97 7.97 0 0 1-6.656 3.564zM967.968 687.988h-63.996c-4.422 0-8-3.578-8-7.998 0-4.422 3.578-8 8-8h63.996c4.422 0 8 3.578 8 8a7.994 7.994 0 0 1-8 7.998z",
    style: {
      fill: "rgba(7, 132, 183, 0.737)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M903.972 687.988a8.016 8.016 0 0 1-8-7.686l-15.998-399.976a8.02 8.02 0 0 1 7.688-8.312c4.31-0.25 8.124 3.266 8.31 7.686l16 399.976a8.02 8.02 0 0 1-7.688 8.31l-0.312 0.002zM967.968 687.988h-0.312a8.02 8.02 0 0 1-7.688-8.31l16-399.976c0.188-4.42 3.812-7.92 8.312-7.686a8.02 8.02 0 0 1 7.688 8.312l-16 399.976a8.012 8.012 0 0 1-8 7.684z",
    style: {
      fill: "rgba(7, 132, 183, 0.737)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M983.968 288.014c-4.422 0-8-3.578-8-8 0-37.154-13.468-55.996-39.998-55.996s-39.998 18.842-39.998 55.996c0 4.422-3.578 8-7.998 8-4.422 0-8-3.578-8-8 0-45.746 20.404-71.996 55.996-71.996s55.998 26.25 55.998 71.996c0 4.422-3.578 8-8 8z",
    style: {
      fill: "rgba(7, 132, 183, 0.737)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M951.97 224.018h-31.998c-4.422 0-8-3.578-8-8 0-4.42 3.578-8 8-8h31.998a7.994 7.994 0 0 1 7.998 8c0 4.422-3.578 8-7.998 8zM935.97 496a7.994 7.994 0 0 1-7.998-8V248.016c0-4.42 3.578-8 7.998-8 4.422 0 8 3.578 8 8v239.986a7.994 7.994 0 0 1-8 7.998zM967.968 719.988h-63.996c-4.422 0-8-3.578-8-8s3.578-8 8-8h63.996c4.422 0 8 3.578 8 8s-3.578 8-8 8z",
    style: {
      fill: "rgba(7, 132, 183, 0.737)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M967.968 719.988c-4.422 0-8-3.578-8-8v-31.998c0-4.422 3.578-8 8-8s8 3.578 8 8v31.998c0 4.422-3.578 8-8 8zM903.972 719.988c-4.422 0-8-3.578-8-8v-31.998c0-4.422 3.578-8 8-8s8 3.578 8 8v31.998c0 4.422-3.578 8-8 8zM967.968 815.98h-63.996c-4.422 0-8-3.578-8-7.998 0-4.422 3.578-8 8-8h63.996c4.422 0 8 3.578 8 8a7.994 7.994 0 0 1-8 7.998z",
    style: {
      fill: "rgba(7, 132, 183, 0.737)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M967.968 815.98c-4.422 0-8-3.578-8-7.998v-95.994c0-4.422 3.578-8 8-8s8 3.578 8 8v95.994a7.994 7.994 0 0 1-8 7.998zM903.972 815.98c-4.422 0-8-3.578-8-7.998v-95.994c0-4.422 3.578-8 8-8s8 3.578 8 8v95.994a7.994 7.994 0 0 1-8 7.998zM791.98 959.972c-4.422 0-8-3.578-8-8V104.026c0-4.422 3.578-8 8-8s8 3.578 8 8v847.948a7.994 7.994 0 0 1-8 7.998z",
    style: {
      fill: "rgba(7, 132, 183, 0.737)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M791.98 959.972H104.02c-4.42 0-8-3.578-8-8s3.578-8 8-8h687.96c4.422 0 8 3.578 8 8s-3.578 8-8 8z",
    style: {
      fill: "rgba(7, 132, 183, 0.737)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.02 959.972c-4.42 0-8-3.578-8-8V8.032c0-4.422 3.578-8 8-8 4.422 0 8 3.578 8 8v943.942a7.994 7.994 0 0 1-8 7.998z",
    style: {
      fill: "rgba(7, 132, 183, 0.737)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M695.986 16.03H104.02c-4.42 0-8-3.578-8-8 0-4.422 3.578-8 8-8h591.966a7.994 7.994 0 0 1 7.998 8c0 4.422-3.578 8-7.998 8z",
    style: {
      fill: "rgba(7, 132, 183, 0.737)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M791.98 112.024a7.976 7.976 0 0 1-5.656-2.344L690.33 13.686a8 8 0 0 1 11.31-11.312l95.996 95.994a8 8 0 0 1-5.656 13.656zM679.986 128.024a7.994 7.994 0 0 1-7.998-8V40.03c0-4.422 3.578-8 7.998-8 4.422 0 8 3.578 8 8v79.994c0 4.422-3.578 8-8 8z",
    style: {
      fill: "rgba(7, 132, 183, 0.737)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M759.982 128.024h-79.996a7.994 7.994 0 0 1-7.998-8c0-4.42 3.578-8 7.998-8h79.996a7.994 7.994 0 0 1 7.998 8c0 4.422-3.578 8-7.998 8zM695.986 432.004H200.014c-4.42 0-8-3.578-8-8 0-4.422 3.578-8 8-8h495.972a7.994 7.994 0 0 1 7.998 8c0 4.422-3.578 8-7.998 8zM695.986 496H200.014c-4.42 0-8-3.578-8-8 0-4.422 3.578-8 8-8h495.972a7.994 7.994 0 0 1 7.998 8c0 4.422-3.578 8-7.998 8z",
    style: {
      fill: "rgba(7, 132, 183, 0.737)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M695.986 559.996H200.014c-4.42 0-8-3.578-8-7.998 0-4.422 3.578-8 8-8h495.972a7.994 7.994 0 0 1 7.998 8 7.994 7.994 0 0 1-7.998 7.998z",
    style: {
      fill: "rgba(7, 132, 183, 0.737)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M695.986 623.992H200.014c-4.42 0-8-3.578-8-7.998 0-4.422 3.578-8 8-8h495.972a7.994 7.994 0 0 1 7.998 8 7.994 7.994 0 0 1-7.998 7.998z",
    style: {
      fill: "rgba(7, 132, 183, 0.737)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456 687.988H200.014c-4.42 0-8-3.578-8-7.998 0-4.422 3.578-8 8-8H456c4.422 0 8 3.578 8 8 0 4.42-3.58 7.998-8 7.998z",
    style: {
      fill: "rgba(7, 132, 183, 0.737)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.01 320.012c-52.934 0-95.994-43.06-95.994-95.994s43.06-95.994 95.994-95.994 95.994 43.06 95.994 95.994-43.06 95.994-95.994 95.994z m0-175.99c-44.106 0-79.996 35.888-79.996 79.996s35.888 79.996 79.996 79.996 79.996-35.888 79.996-79.996-35.89-79.996-79.996-79.996z",
    style: {
      fill: "rgba(7, 132, 183, 0.737)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.01 288.014a8 8 0 0 1-5.656-13.656l55.998-55.998a8 8 0 0 1 11.31 11.312l-55.996 55.996a7.966 7.966 0 0 1-5.656 2.346z",
    style: {
      fill: "rgba(7, 132, 183, 0.737)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.006 256.016a7.976 7.976 0 0 1-5.656-2.344l-23.998-23.998a8 8 0 0 1 11.31-11.312l24 24a8 8 0 0 1-5.656 13.654z",
    style: {
      fill: "rgba(7, 132, 183, 0.737)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.012 256.016a8 8 0 0 1-5.656-13.656l16-16a8 8 0 1 1 11.312 11.312l-16 16a7.974 7.974 0 0 1-5.656 2.344z",
    style: {
      fill: "rgba(7, 132, 183, 0.737)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.01 256.016a7.98 7.98 0 0 1-5.656-2.344l-16-16a8 8 0 1 1 11.312-11.312l16 16a8 8 0 0 1-5.656 13.656z",
    style: {
      fill: "rgba(7, 132, 183, 0.737)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.01 208.018c-13.232 0-23.998-10.764-23.998-24 0-13.232 10.766-23.998 23.998-23.998 13.234 0 24 10.766 24 23.998 0 13.236-10.764 24-24 24z m0-31.998c-4.414 0-8 3.594-8 8 0 4.406 3.586 8 8 8s8-3.594 8-8c0-4.406-3.586-8-8-8z",
    style: {
      fill: "rgba(7, 132, 183, 0.737)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.022 991.97c-4.42 0-8-3.578-8-8V40.03c0-4.422 3.578-8 8-8 4.422 0 8 3.578 8 8v943.942a7.994 7.994 0 0 1-8 7.998z",
    style: {
      fill: "rgba(7, 132, 183, 0.737)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M759.982 991.97H72.022c-4.42 0-8-3.578-8-8a7.994 7.994 0 0 1 8-7.998h687.96a7.994 7.994 0 0 1 7.998 7.998c0 4.422-3.578 8-7.998 8z",
    style: {
      fill: "rgba(7, 132, 183, 0.737)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M727.984 1023.968H40.024c-4.42 0-8-3.578-8-8s3.578-8 8-8h687.96c4.422 0 8 3.578 8 8s-3.578 8-8 8z",
    style: {
      fill: "rgba(7, 132, 183, 0.737)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.024 1023.968c-4.42 0-8-3.578-8-8V72.028c0-4.422 3.578-8 8-8 4.422 0 8 3.578 8 8v943.942a7.994 7.994 0 0 1-8 7.998z",
    style: {
      fill: "rgba(7, 132, 183, 0.737)"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgreements);
export default __webpack_public_path__ + "static/media/agreements.7c91c9e5e1cf55996d388047b3b0ae1c.svg";
export { ForwardRef as ReactComponent };